import { render, staticRenderFns } from "./editPrivacySetting.vue?vue&type=template&id=1d181833&scoped=true&"
import script from "./editPrivacySetting.vue?vue&type=script&lang=js&"
export * from "./editPrivacySetting.vue?vue&type=script&lang=js&"
import style0 from "./editPrivacySetting.vue?vue&type=style&index=0&id=1d181833&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d181833",
  null
  
)

export default component.exports